module.exports = __webpack_public_path__ + "img/logo.510e21e5.png";